import {useState} from 'react';

import useProfile from '../../../../hooks/providers/useProfile';
import Button from '../../../form/buttons/Button/Button';

const OnboardingMarkStepAsFinishedButton = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {goToNextVideo, currentFlowStep, saveOnboardingVideoProgression} = useProfile();
  const videoAlreadyFinished = currentFlowStep.position === 100;

  if (!currentFlowStep.url_video) return null;

  return (
    <Button
      disabled={isSubmitting || videoAlreadyFinished}
      variant="text"
      onClick={async () => {
        goToNextVideo();

        const videoProgressionPercentage = 100;
        setIsSubmitting(true);
        await saveOnboardingVideoProgression(currentFlowStep.step_id, videoProgressionPercentage);
        setIsSubmitting(false);
      }}
      sx={{
        display: 'block',
        margin: '0 auto',
        fontSize: 11.5,
        textDecoration: 'underline',
        mb: 1.5,
        py: 0.1,
        px: 0.5
      }}
      color="primary"
    >
      Marquer comme terminé
    </Button>
  );
};

export default OnboardingMarkStepAsFinishedButton;
